import React from 'react';
import { useSelector } from 'react-redux';

function AttendeeRecorderName({ name, userkey, isCircular = false }) {
    const videoContainerSettings = useSelector(state => state.conf.videoContainerSettings);

    return (
        <>
            {
                videoContainerSettings?.show_names_on_videos && <div
                    style={{
                        textAlign: isCircular ? 'center' : 'left',
                        ...(isCircular && {
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            height: '100%',
                            width: '100%',
                            position: 'absolute',
                            top: 0,
                            left: 0,
                        }),
                    }}
                    key={userkey || ''}
                    dangerouslySetInnerHTML={{ __html: name?.name + ' is recording a video' }}
                />
            }
        </>

    );

}

export default AttendeeRecorderName;
